import { Button, Link } from "@shapr3d/frontend-lib";

import style from "./ModelViewerWarningPage.module.css";

interface ModelViewerWarningPageProps {
  onDismissWarning: () => void;
  backgroundImage?: string;
}

export function ModelViewerWarningPage({
  onDismissWarning,
  backgroundImage,
}: ModelViewerWarningPageProps) {
  return (
    <div className={style.container}>
      {backgroundImage && (
        <>
          <img src={backgroundImage} alt="Model Image" className={style.backgroundImage} />
          <div className={style.overlay} />
        </>
      )}
      <div className={style.content}>
        <h1 className={style.title}>Complex model</h1>
        <p className={style.description}>
          This model may be too complex for your browser to load. You can still try loading it, but
          it may affect browser performance.
        </p>
        <Button onClick={onDismissWarning} variant="grayscale">
          Load model
        </Button>
        <Link className={style.learnMore} href="https://support.shapr3d.com/" target="_blank">
          Learn more ...
        </Link>
      </div>
    </div>
  );
}
